import { styled } from "src/styles/stitches.config";

export const AudioVisualizerWrapper = styled("canvas", {
  position: "absolute",
  width: "100%",
  height: "100%",
  zIndex: "0",
});
